import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { AutosProducts } from "src/constants/product-codes";

export class VehicleOffer extends BaseModel {
    @Expose() code: AutosProducts = AutosProducts.AUTOENLATADO;
    @Expose() description = "";
}
